var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page"},[_c('div',{staticClass:"centered"},[_vm._m(0),_c('p',[_c('strong',[_vm._v("Test Result (Cookies):")]),_vm._v(" "+_vm._s(_vm.testOutput))]),_c('p',[_c('strong',[_vm._v("Test Result (LS):")]),_vm._v(" "+_vm._s(_vm.testOutput))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('i',{staticClass:"not-found-icon nc-icon nc-puzzle-10"}),_vm._v("Cookies Test")])
}]

export { render, staticRenderFns }